import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";
import "./Cards.css";

export default function Cards({
  elementos = [],
  filtros = {},
  filasDatos = [],
  reglasDeEstados = [],
  mapaEstadosClases = {},
  mapaDeComponentes = {},
  origenComponente = "Cards",
  fNotificarActualizacionDeTabla,

  // ============================================================
  // NUEVO:
  // Datos externos que pueden utilizar las reglasVisible
  // ============================================================
  contextoReglas = {},
}) {
  const { ecv_u, cv_u, esComputadora } = useContext(Contexto);

  const [v_c, ev_c] = useState({
    // MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},

    // PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},

    // PROCESANDO ACCION
    procesandoAccion_mostrar: false,

    // POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},

    // ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });

  const [v_u, ev_u] = useState({
    modal_mostrar: false,
    do_registroEvento: null,
    d_registroEventoTipo: null,
    d_registroEventoComponente: null,
    do_registroEventoParametros: null,
    d_registroEventoEndpoint: null,
    d_registroEventoTimeout: null,
    d_registroEventoTitulo: null,
    do_estilosModal: null,
  });

  useEffect(() => {
    console.log(elementos);
    console.log(filasDatos);
  }, [elementos]);

  // ============================================================
  // 1. MAPA AUTOMÁTICO DE FILTROS
  // ============================================================

  const mapaFiltroACampo = {};

  filasDatos.forEach((bloque) => {
    bloque.items?.forEach((subItem) => {
      if (subItem.label && subItem.campo) {
        mapaFiltroACampo[subItem.label] = subItem.campo;
      }
    });
  });

  // ============================================================
  // 2. FILTRADO INTERNO DE ELEMENTOS
  // ============================================================

  const elementosFiltrados = elementos.filter((item) => {
    if (!filtros || Object.keys(filtros).length === 0) {
      return true;
    }

    for (const [nombreFiltro, config] of Object.entries(filtros)) {
      const { valor, operador, tipo } = config;

      if (valor === null || valor === undefined || valor === "") {
        continue;
      }

      const campoReal = mapaFiltroACampo[nombreFiltro] || nombreFiltro;

      const valorItem = obtenerValorSegunRuta(item, campoReal);

      if (valorItem === null || valorItem === undefined) {
        return false;
      }

      const tipoNormalizado = String(tipo || "").toLowerCase();

      const opNormalizado = String(operador || "").toLowerCase();

      // ========================================================
      // TIPOS NUMÉRICOS
      // ========================================================

      if (
        ["int", "float", "double", "number", "num", "moneda"].includes(
          tipoNormalizado,
        )
      ) {
        const numItem = Number(valorItem);
        const numFiltro = Number(valor);

        if (isNaN(numFiltro) || numItem === null || isNaN(numItem)) {
          return false;
        }

        switch (opNormalizado) {
          case "==":
          case "=":
            if (!(numItem === numFiltro)) return false;
            break;

          case "!=":
          case "<>":
            if (!(numItem !== numFiltro)) return false;
            break;

          case ">":
            if (!(numItem > numFiltro)) return false;
            break;

          case ">=":
            if (!(numItem >= numFiltro)) return false;
            break;

          case "<":
            if (!(numItem < numFiltro)) return false;
            break;

          case "<=":
            if (!(numItem <= numFiltro)) return false;
            break;

          default:
            if (!(numItem === numFiltro)) return false;
            break;
        }
      }

      // ========================================================
      // TIPOS FECHA
      // ========================================================
      else if (["date", "datetime", "fecha"].includes(tipoNormalizado)) {
        const fechaItemObj = new Date(valorItem);

        let valorFiltroStr = String(valor);

        if (!valorFiltroStr.includes("T") && !valorFiltroStr.includes(" ")) {
          valorFiltroStr += "T00:00:00";
        }

        const fechaFiltroObj = new Date(valorFiltroStr);

        if (isNaN(fechaItemObj.getTime()) || isNaN(fechaFiltroObj.getTime())) {
          return false;
        }

        const timeItem = fechaItemObj.getTime();

        const timeFiltro = fechaFiltroObj.getTime();

        switch (opNormalizado) {
          case "==":
          case "=":
            if (!(timeItem === timeFiltro)) return false;
            break;

          case "!=":
          case "<>":
            if (!(timeItem !== timeFiltro)) return false;
            break;

          case ">":
            if (!(timeItem > timeFiltro)) return false;
            break;

          case ">=":
            if (!(timeItem >= timeFiltro)) return false;
            break;

          case "<":
            if (!(timeItem < timeFiltro)) return false;
            break;

          case "<=":
            if (!(timeItem <= timeFiltro)) return false;
            break;

          default:
            if (!(timeItem >= timeFiltro)) return false;
            break;
        }
      }

      // ========================================================
      // TIPOS TEXTO
      // ========================================================
      else if (["str", "string"].includes(tipoNormalizado)) {
        const strItem = String(valorItem).toLowerCase();

        const strFiltro = String(valor).toLowerCase();

        switch (opNormalizado) {
          case "contains":
            if (!strItem.includes(strFiltro)) {
              return false;
            }
            break;

          case "equals":
          case "==":
          case "=":
            if (!(strItem === strFiltro)) return false;
            break;

          case "!=":
          case "<>":
            if (!(strItem !== strFiltro)) return false;
            break;

          default:
            if (!strItem.includes(strFiltro)) {
              return false;
            }
            break;
        }
      }
    }

    return true;
  });

  // ============================================================
  // MODAL
  // ============================================================

  return (
    <>
      {v_u.modal_mostrar &&
        Array.from({ length: 1 }).map((_, idx) => {
          const funcionCerrar = () => {
            _f_.asignar(ev_u, {
              modal_mostrar: false,
            });

            _f_.asignar(ev_u, {
              do_estilosModal: null,
              do_registroEvento: null,
              d_registroEventoTipo: null,
              do_registroEventoParametros: null,
              d_registroEventoEndpoint: null,
              d_registroEventoTimeout: null,
              d_registroEventoTitulo: null,
            });
          };

          const Etiqueta = mapaDeComponentes?.[v_u?.d_registroEventoComponente];

          const parametrosEtiqueta = {
            origenComponente,
            registro: v_u.do_registroEvento,
            parametros: v_u.do_registroEventoParametros,
            tipoEvento: v_u.d_registroEventoTipo,
            fCerrarComponente: funcionCerrar,
            fEstablecerVariablesTabla: ev_u,
            fActualizarTablaTotal: fNotificarActualizacionDeTabla,
          };

          return (
            <ModalInformacion
              key={idx}
              titulo={v_u.d_registroEventoTitulo}
              estilos={v_u.do_estilosModal}
              fCerrar={() => {
                _f_.asignar(ev_u, {
                  modal_mostrar: false,
                });

                if (Etiqueta) {
                  fNotificarActualizacionDeTabla?.(true);
                }
              }}
            >
              {Etiqueta ? (
                <Etiqueta {...parametrosEtiqueta} />
              ) : (
                "componente no asociado"
              )}
            </ModalInformacion>
          );
        })}

      {/* ========================================================
          ELEMENTOS
      ======================================================== */}
      <div className = "CardsCSS-contenedor">
      {elementosFiltrados.map((itemElemento, idx_elemento) => {
        // ======================================================
        // 3. EVALUACIÓN DE ESTADOS
        // ======================================================

        let clasesEstadoDinamicas = "";

        if (reglasDeEstados && reglasDeEstados.length > 0) {
          const resultadosEstados = evaluarReglasDeEstadosConRutas(
            reglasDeEstados,
            itemElemento,
          );

          resultadosEstados.forEach((est) => {
            if (est.resultado && mapaEstadosClases[est.tipo]) {
              clasesEstadoDinamicas += ` ${mapaEstadosClases[est.tipo]}`;
            }
          });
        }

        return (
          <div
            key={idx_elemento}
            className={`CardsCSS-categoria ${clasesEstadoDinamicas}`}
            {...(itemElemento?.funcionEvento?.tipo
              ? {
                  [itemElemento.funcionEvento?.tipo]: (evento) => {
                    _f_.asignar(ev_u, {
                      modal_mostrar: true,
                    });

                    _f_.asignar(ev_u, {
                      do_registroEvento: elementosFiltrados[idx_elemento],

                      d_registroEventoTipo: evento.type,

                      d_registroEventoComponente:
                        elementosFiltrados[idx_elemento]?.funcionEvento
                          ?.componente,

                      do_registroEventoParametros: null,

                      d_registroEventoEndpoint:
                        elementosFiltrados[idx_elemento]?.funcionEvento
                          ?.endpoint,

                      d_registroEventoTimeout:
                        elementosFiltrados[idx_elemento]?.funcionEvento
                          ?.timeout,

                      d_registroEventoTitulo:
                        elementosFiltrados[idx_elemento]?.funcionEvento?.titulo,

                      do_estilosModal:
                        elementosFiltrados[idx_elemento]?.funcionEvento
                          ?.estilos,
                    });
                  },
                }
              : {})}
          >
            {filasDatos.map((bloque, bIdx) => {
              // ==================================================
              // 4. FILTRAR ITEMS VISIBLES
              // ==================================================

              const itemsValidos = bloque.items?.filter((subItem) => {
                // --------------------------------------------
                // No existe
                // --------------------------------------------

                if (!subItem) {
                  return false;
                }

                // --------------------------------------------
                // OCULTO SIN REGLAS
                //
                // Si oculto=true y no tiene reglasVisible,
                // permanece oculto.
                // --------------------------------------------

                if (subItem.oculto === true && !subItem.reglasVisible) {
                  return false;
                }

                // --------------------------------------------
                // NUEVO:
                // EVALUAR REGLAS DE VISIBILIDAD
                // --------------------------------------------

                if (subItem.reglasVisible) {
                  const visible = evaluarReglasVisibilidad(
                    subItem.reglasVisible,
                    itemElemento,
                    contextoReglas,
                  );

                  if (!visible) {
                    return false;
                  }
                }

                // --------------------------------------------
                // Si oculto=true pero tiene reglasVisible
                // y las reglas se cumplen, continúa.
                // --------------------------------------------

                // Caso 1:
                // Tiene campo
                if (subItem.campo) {
                  const valorCrudo = obtenerValorSegunRuta(
                    itemElemento,
                    subItem.campo,
                  );

                  return (
                    valorCrudo !== null &&
                    valorCrudo !== undefined &&
                    valorCrudo !== ""
                  );
                }

                // Caso 2:
                // valor string = ruta
                if (typeof subItem.valor === "string") {
                  const valorCrudo = obtenerValorSegunRuta(
                    itemElemento,
                    subItem.valor,
                  );

                  return (
                    valorCrudo !== null &&
                    valorCrudo !== undefined &&
                    valorCrudo !== ""
                  );
                }

                // Caso 3:
                // valor directo / JSX
                return (
                  subItem.valor !== null &&
                  subItem.valor !== undefined &&
                  subItem.valor !== ""
                );
              });

              // ==================================================
              // 5. SI NO HAY ITEMS, NO MOSTRAR FILA
              // ==================================================

              if (!itemsValidos || itemsValidos.length === 0) {
                return null;
              }

              const numColumnas = bloque.columnas || 1;

              const alineacionFila = bloque.alineacion || "normal";

              return (
                <div
                  key={bIdx}
                  className={`CardsCSS-fila-bloque CardsCSS-align-${alineacionFila}`}
                  style={{
                    gridTemplateColumns: `repeat(${numColumnas}, 1fr)`,
                  }}
                >
                  {itemsValidos.map((subItem, subIdx) => {
                    // ==========================================
                    // 6. OBTENER CAMPO
                    // ==========================================

                    const campoClave = subItem.campo
                      ? subItem.campo
                      : typeof subItem.valor === "string"
                        ? subItem.valor
                        : null;

                    const valorCrudo = campoClave
                      ? obtenerValorSegunRuta(itemElemento, campoClave)
                      : null;

                    // ==========================================
                    // 7. VALOR FINAL
                    // ==========================================

                    let valorFinal = subItem.valor;

                    if (typeof subItem.valor === "function") {
                      valorFinal = subItem.valor(valorCrudo, itemElemento);
                    } else if (campoClave) {
                      valorFinal = valorCrudo;
                    }

                    // ==========================================
                    // 8. EVENTO DEL ITEM
                    // ==========================================

                    const eventoProps = subItem?.funcionEvento?.tipo
                      ? {
                          [subItem.funcionEvento.tipo]: (evento) => {
                            evento.stopPropagation();

                            _f_.asignar(ev_u, {
                              modal_mostrar: true,
                            });

                            _f_.asignar(ev_u, {
                              do_registroEvento:
                                elementosFiltrados[idx_elemento],

                              d_registroEventoTipo: evento.type,

                              d_registroEventoComponente:
                                subItem?.funcionEvento?.componente,

                              do_registroEventoParametros: null,

                              d_registroEventoEndpoint:
                                subItem?.funcionEvento?.endpoint,

                              d_registroEventoTimeout:
                                subItem?.funcionEvento?.timeout,

                              d_registroEventoTitulo:
                                subItem?.funcionEvento?.titulo,

                              do_estilosModal: subItem?.funcionEvento?.estilos,
                            });
                          },
                        }
                      : {};

                    // ==========================================
                    // 9. RENDER ITEM
                    // ==========================================

                    return (
                      <div
                        key={subIdx}
                        className={`CardsCSS-columna-dato ${
                          subItem.claseContenedor || ""
                        }`}
                        
                      >
                        {subItem.label && subItem.mostrarLabel !== false && (
                          <span className="CardsCSS-label">
                            {subItem.label}
                          </span>
                        )}

                        <span
                          className={`CardsCSS-dato ${subItem.claseDato || ""}`}
                          {...eventoProps}
                        >
                          {valorFinal}
                        </span>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        );
      })}
      </div>
    </>
  );
}

// ============================================================
// OBTENER VALOR SEGÚN RUTA
// ============================================================

function obtenerValorSegunRuta(objeto, ruta) {
  if (!objeto || !ruta) {
    return null;
  }

  if (objeto[ruta] !== undefined) {
    return objeto[ruta];
  }

  return ruta
    .split(".")
    .reduce((acc, parte) => (acc ? acc[parte] : null), objeto);
}

// ============================================================
// EVALUAR REGLAS DE VISIBILIDAD
// ============================================================

function evaluarReglasVisibilidad(reglas, datos, contexto) {
  if (!Array.isArray(reglas) || reglas.length === 0) {
    return true;
  }

  return evaluarReglasConRutas(reglas, datos, contexto);
}

// ============================================================
// EVALUAR REGLAS
//
// Cada regla puede consultar:
//
// 1. datos del registro:
//    campo: "entregado"
//
// 2. contexto externo:
//    campo: "rolUsuarioSesion"
//    origen: "contexto"
//
// Si no se especifica origen,
// se busca primero en el registro.
//
// Si no existe ahí, también puede buscarse
// en contexto.
// ============================================================

function evaluarReglasConRutas(reglas, datos, contexto = {}) {
  if (!reglas || reglas.length === 0) {
    return false;
  }

  const primeraRegla = reglas[0];

  const valorInicial = obtenerValorRegla(primeraRegla, datos, contexto);

  let acumulado = evaluarRegla(primeraRegla, valorInicial);

  for (let i = 1; i < reglas.length; i++) {
    const reglaAnterior = reglas[i - 1];

    const reglaActual = reglas[i];

    const valorActual = obtenerValorRegla(reglaActual, datos, contexto);

    const resultadoActual = evaluarRegla(reglaActual, valorActual);

    acumulado = _f_.aplicarConector(
      acumulado,
      reglaAnterior.conector,
      resultadoActual,
    );
  }

  return Boolean(acumulado);
}

// ============================================================
// OBTENER VALOR DE UNA REGLA
// ============================================================

function obtenerValorRegla(regla, datos, contexto) {
  // ------------------------------------------------------------
  // ORIGEN EXPLÍCITO: CONTEXTO
  // ------------------------------------------------------------

  if (regla.origen === "contexto") {
    return obtenerValorSegunRuta(contexto, regla.campo);
  }

  // ------------------------------------------------------------
  // ORIGEN EXPLÍCITO: REGISTRO
  // ------------------------------------------------------------

  if (regla.origen === "registro") {
    return obtenerValorSegunRuta(datos, regla.campo);
  }

  // ------------------------------------------------------------
  // SIN ORIGEN:
  //
  // Primero busca en el registro.
  // Si no existe, busca en contexto.
  // ------------------------------------------------------------

  const valorRegistro = obtenerValorSegunRuta(datos, regla.campo);

  if (valorRegistro !== null && valorRegistro !== undefined) {
    return valorRegistro;
  }

  return obtenerValorSegunRuta(contexto, regla.campo);
}

// ============================================================
// EVALUAR UNA REGLA INDIVIDUAL
// ============================================================

function evaluarRegla(regla, valorActual) {
  // ==========================================================
  // OPERADOR "in"
  //
  // Ejemplo:
  //
  // campo: "rolUsuarioSesion"
  // operador: "in"
  // criterio: ["SADM", "DIST"]
  // ==========================================================

  if (String(regla.operador).toLowerCase() === "in") {
    const criterios = Array.isArray(regla.criterio)
      ? regla.criterio
      : [regla.criterio];

    return criterios.some(
      (criterio) => String(valorActual) === String(criterio),
    );
  }

  // ==========================================================
  // OPERADOR "not in"
  // ==========================================================

  if (String(regla.operador).toLowerCase() === "not in") {
    const criterios = Array.isArray(regla.criterio)
      ? regla.criterio
      : [regla.criterio];

    return !criterios.some(
      (criterio) => String(valorActual) === String(criterio),
    );
  }

  // ==========================================================
  // RESTO DE OPERADORES
  //
  // Utilizamos tu función existente.
  // ==========================================================

  return _f_.evaluarOperador(valorActual, regla.operador, regla.criterio);
}

// ============================================================
// REGLAS DE ESTADOS
// ============================================================

const evaluarReglasDeEstadosConRutas = (reglasDeEstados, datos) => {
  if (!reglasDeEstados || !Array.isArray(reglasDeEstados)) {
    return [];
  }

  return reglasDeEstados.map((estado) => ({
    tipo: estado.tipo,
    resultado: evaluarReglasConRutas(estado.reglas, datos),
  }));
};
